import Constants from '../../constants'

const getDefaultState = () => {
  return {
    all: [],
    stations: {
      departure: {
        name: Constants.DEFAULT_STATION,
        isStation: true,
        location: {}
      },
      arrival: {
        name: Constants.DEFAULT_STATION,
        isStation: true,
        location: {}
      }
    },
    editable: null
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getStations: (state) => state.stations,
  getDestination: (state) => (index) => state.all.find(destination => destination.index === index),
  getDepatureStation: (state) => state.stations.departure,
  getArrivalStation: (state) => state.stations.arrival,
  getEditable: (state) => state.editable
}

const actions = {
  updateDestinations ({ commit }, destinations) {
    commit('setDestinations', destinations)
  },
  buildDestinations ({ commit }, destinations) {
    commit('setBuildDestinations', destinations)
  },
  updateDepartureStationLocation ({ commit }, location) {
    commit('setDepartureStationLocation', location)
  },
  updateArrivalStationLocation ({ commit }, location) {
    commit('setArrivalStationLocation', location)
  },
  updateDepartureStation ({ commit }, name) {
    commit('setDepartureStationName', name)
  },
  updateArrivalStation ({ commit }, name) {
    commit('setArrivalStationName', name)
  },
  updateStations ({ commit }, stations) {
    commit('setStations', stations)
  },
  spliceDestination ({ commit }, params) {
    commit('spliceDestination', params)
  },
  deleteDestination ({ commit }, destination) {
    commit('destroyDestination', destination)
  },
  updateTime ({ commit, dispatch }, params) {
    dispatch('condition/updateTime', params.arrivalTime, { root: true })
    commit('setTime', params)
  },
  updateEditable ({ commit }, params) {
    commit('updateEditable', params)
  },
  resetEditable({ commit }) {
    commit('resetEditable')
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setDestinations (state, destinations) {
    state.all = destinations
  },
  setBuildDestinations (state, destinations) {
    const defaultVisit = 60

    state.all = destinations.map((destination, index) => {
      return {
        ...destination,
        index: index,
        type: 'place',
        visit: destination.visit ? destination.visit : defaultVisit
      }
    })
  },
  setDepartureStationLocation (state, location) {
    state.stations.departure.location = location
  },
  setArrivalStationLocation (state, location) {
    state.stations.arrival.location = location
  },
  setDepartureStationName (state, name) {
    state.stations.departure.name = name
  },
  setArrivalStationName (state, name) {
    state.stations.arrival.name = name
  },
  setStations (state, stations) {
    state.stations = stations
  },
  spliceDestination (state, { route, place }) {
    state.all.splice(route.index, 0, {
      ...place,
      lock: false,
      visit: place.visit !== undefined ? place.visit : 60
    })

    state.all = state.all.map((d, index) => {
      return {
        ...d,
        index: index
      }
    })

    state.editable = {
      index: route.index
    }
  },
  destroyDestination (state, destination) {
    state.all.splice(destination.index, 1)
    state.all = state.all.map((d, index) => {
      return {
        ...d,
        index: index
      }
    })

    state.editable = {
      index: destination.index - 1
    }
  },
  setTime (state, params) {
    const destination = state.all[params.destination.index]

    // state.all.forEach(d => d.lock = false)
    if (destination.genreIds.includes('stay')) {
      destination.checkIn = params.arrivalTime
    }
    destination.visit = params.visit
    // destination.lock = true

    state.editable = {
      index: params.destination.index
    }
  },
  updateEditable(state, params) {
    if (state.editable !== null) {
      state.editable = {
        index: (params !== undefined && params.destination !== undefined ? params.destination.index : state.editable.index)
      }
    }
  },
  resetEditable (state) {
    state.editable = null;
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
